import { render, staticRenderFns } from "./index.vue?vue&type=template&id=eb0bbbce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=eb0bbbce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0bbbce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb0bbbce')) {
      api.createRecord('eb0bbbce', component.options)
    } else {
      api.reload('eb0bbbce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=eb0bbbce&scoped=true", function () {
      api.rerender('eb0bbbce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/textbookVersions/index.vue"
export default component.exports